import { Brand } from "@/types/entities";
import React from "react";
import { Styled } from "./styles";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import storage from "@/utils/storage";
import { isString } from "@/utils/validations";
import { Settings } from "@dippi/icons";
import { getRoutes, shorten } from "@/utils/helpers";

type ExtendedBrand = Brand & {
    index: number;
};

const ListItem: React.FC<ExtendedBrand> = brand => {
    const { _id: bid, title, media, index } = brand;

    const navigate = useNavigate();
    const routes = getRoutes();

    const onSelect = () => {
        if (!isString(bid)) return;

        storage.setItem("bid", bid);
        navigate(routes.products(bid));
    };

    const onOpenSettings = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();

        if (!isString(bid)) return;

        storage.setItem("bid", bid);
        navigate(routes.brandSettings(bid));
    };

    const url: string | undefined = media && media.variants?.[3]?.url;

    return (
        <Styled.Item onClick={onSelect} data-testid={`brand-box-${index}`}>
            {url ? (
                <Styled.Logo src={url} alt={title} />
            ) : (
                <Styled.LogoPlaceholder>
                    <Typography variant="h2" marginBottom={0} textTransform="uppercase">
                        {title[0]}
                    </Typography>
                </Styled.LogoPlaceholder>
            )}
            <Typography textAlign="center" width="100%" sx={{ wordWrap: "break-word" }}>
                {shorten(title, 35)}
            </Typography>
            <Styled.Cog onClick={onOpenSettings} className="cog" data-testid="cog-icon">
                <Settings />
            </Styled.Cog>
        </Styled.Item>
    );
};

export default ListItem;
